import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { changeLanguage, LOCALE_STORAGE_KEY } from "../i18n";
import { isBinapsisBrand } from "../utils/utils";

export function useBrandTranslation() {
  const { t, i18n } = useTranslation();
  const isMultilingual = isBinapsisBrand();

  const bt = useCallback(
    (key, defaultValue, options) => {
      if (!isMultilingual) {
        if (options && typeof defaultValue === "string") {
          return defaultValue.replace(/\{\{(\w+)\}\}/g, (_, token) =>
            options[token] != null ? String(options[token]) : ""
          );
        }
        return defaultValue ?? key;
      }
      return t(key, { defaultValue, ...options });
    },
    [t, isMultilingual]
  );

  const setLanguage = useCallback(
    (lng) => {
      if (!isMultilingual) return Promise.resolve();
      return changeLanguage(lng);
    },
    [isMultilingual]
  );

  return {
    t: bt,
    i18n,
    language: isMultilingual ? i18n.language : "es",
    setLanguage,
    isMultilingual,
    LOCALE_STORAGE_KEY,
  };
}

export default useBrandTranslation;
